export default {
  LOAD_PRODUCT: '@@Byside/LOAD_PRODUCT',
};
